import { render, staticRenderFns } from "./earnings.vue?vue&type=template&id=4f1b97b0&scoped=true"
import script from "./earnings.vue?vue&type=script&lang=js"
export * from "./earnings.vue?vue&type=script&lang=js"
import style0 from "./earnings.vue?vue&type=style&index=0&id=4f1b97b0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1b97b0",
  null
  
)

export default component.exports